import React from 'react';

export default function ContactInfo() {
  return (
    <div className="space-y-6">
      <div className="bg-card rounded-2xl border border-border p-6 shadow-sm">
        <h2 className="text-xl font-semibold text-card-foreground mb-4">Get in Touch</h2>
        <div className="space-y-4">
          <div>
            <h3 className="font-medium text-card-foreground">Email Support</h3>
            <a 
              href="mailto:support@skillbinder.com" 
              className="text-muted-foreground hover:text-primary hover:underline transition-colors"
            >
              support@skillbinder.com
            </a>
            <p className="text-sm text-muted-foreground mt-1">
              We typically respond within 24 hours
            </p>
          </div>
          
          <div>
            <h3 className="font-medium text-card-foreground">Business Inquiries</h3>
            <a 
              href="mailto:support@skillbinder.com" 
              className="text-muted-foreground hover:text-primary hover:underline transition-colors"
            >
              support@skillbinder.com
            </a>
            <p className="text-sm text-muted-foreground mt-1">
              Partnerships, media, and enterprise accounts
            </p>
          </div>
          
          <div>
            <h3 className="font-medium text-card-foreground">Response Time</h3>
            <p className="text-muted-foreground">
              Monday - Friday: Within 4-8 hours<br />
              Weekends: Within 24 hours
            </p>
          </div>
        </div>
      </div>

      <div className="bg-card rounded-2xl border border-border p-6 shadow-sm">
        <h2 className="text-xl font-semibold text-card-foreground mb-4">Quick Help</h2>
        <div className="space-y-3">
          <div>
            <h3 className="font-medium text-card-foreground">Getting Started</h3>
            <p className="text-sm text-muted-foreground">
              New to SkillBinder? Check our getting started guide and take the career assessment.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium text-card-foreground">Account Issues</h3>
            <p className="text-sm text-muted-foreground">
              Problems with login, billing, or subscription management? We're here to help.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium text-card-foreground">Technical Problems</h3>
            <p className="text-sm text-muted-foreground">
              App not working as expected? Include details about your device and browser.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-card rounded-2xl border border-border p-6 shadow-sm">
        <h2 className="text-xl font-semibold text-card-foreground mb-4">Company Info</h2>
        <div className="space-y-2 text-sm text-muted-foreground">
          <p><strong className="text-card-foreground">Epoxy Dogs LLC</strong></p>
          <p>Makers of SkillBinder™</p>
          <p>Serving professionals nationwide</p>
          <p>Committed to privacy and security</p>
        </div>
      </div>
    </div>
  );
}